// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-CQJbgiipRQ","input":"input-xaGXGAAvN8","number":"number-tcQhd5exAS","select":"select-NxShRE7ZCF"};